<template>
    <LazyUiProductsSectionsProductGrid :blok="blok" :airport="airport" />
</template>

<script setup>
defineProps({ blok: Object, airport: Object });
</script>

<style lang="postcss" scoped>
:deep(.summary-info) {
    .airport-stats {
        @apply py-12 mx-auto text-sm leading-6;

        .airport-rating {
            @apply mb-3;

            .rating-stars {
                @apply inline-block mr-2 text-xs;
            }
            .full-star {
                @apply text-tertiary;
            }
            .rating-star-icon {
                @apply mx-0.5;
            }
        }
        .stats-table-container {
            @apply mb-4;
        }
        .stats-label {
            @apply w-[175px];
        }

        strong {
            font-weight: 700;
        }
    }
}
</style>
